import { useMemo } from 'react';
import { BOOLEAN_STRING } from '@sib/config';
import { useTranslation } from '@sib/i18n';

export const useTaskCompletionOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t('completed'), value: BOOLEAN_STRING.True },
      { label: t('uncompleted'), value: BOOLEAN_STRING.False },
    ],
    [t]
  );
};
